import React from 'react'
import PropTypes from 'prop-types'
import { Navigate, useLocation } from 'react-router-dom'
import { TOKEN_KEY } from '../config/Constants'

/**
 * Simple route guard: if there is no auth token in localStorage,
 * redirect to /login.
 */
const RequireAuth = ({ children }) => {
  const location = useLocation()
  const token = localStorage.getItem(TOKEN_KEY)

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return children
}

RequireAuth.propTypes = {
  children: PropTypes.node,
}

export default RequireAuth
